import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidQuery,
  UpdateBidPublicityMutation,
  UpdateBidPublicityMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const updateBidPublicity = graphql(`
  mutation updateBidPublicity($input: UpdateBidPublicityRequest!) {
    updateBidPublicity(UpdateBidPublicityRequest: $input) {
      id
      opportunityId
      publicHash
    }
  }
`);

export function useUpdateBidPublicity(
  options?: UseMutationOptions<
    UpdateBidPublicityMutation,
    unknown,
    UpdateBidPublicityMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(updateBidPublicity, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      queryClient.setQueryData(
        ["bid", data.updateBidPublicity.id],
        (prevData: BidQuery | undefined) => {
          if (!prevData) return prevData;
          return {
            bid: {
              ...prevData.bid,
              publicHash: data.updateBidPublicity.publicHash,
            },
          };
        },
      );
    },
  });
  return { data: data?.updateBidPublicity, ...rest };
}
